import React, { Component } from "react";
import Layout from "../../components/Layout";
import NewHealth from "../../pages/NewHealth";
import Loading from "../../components/Base/Loading";

/* Container for New Posts page */

class NewHealthContainer extends Component {
  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const { school, profile } = this.props;
    return (
      <Layout {...this.props} noSideBar noFooter>
        {profile === null || school === null ? (
          <Loading />
        ) : (
          <NewHealth {...this.props} />
        )}
      </Layout>
    );
  }
}

export default NewHealthContainer;
